<template>
  <el-input type="text" v-if="item.propertyValueType === 0" placeholder="请输入" @input="handleInput($event)" :value="localValue">
    <template slot="append" v-if="hasValueUnit(item)">{{ item.valueUnit[0] }}</template>
  </el-input>
  <div v-else>
    <el-input-digit
      :value="localValue"
      :width="hasValueUnit(item) ? '72%' : '100%'"
      placeholder="请输入"
      format
      nullable
      :precision="0"
      @change="handleInput"
      :max="item.maxValue ? Number(item.maxValue) : ''"
    >
      <span v-if="hasValueUnit(item)">{{ valueUnit || item.valueUnit[0] }}</span>
    </el-input-digit>
  </div>
</template>

<script>
export default {
  name: 'properties-input',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    item: {
      type: Object,
      default() {
        return {};
      },
    },
    value: {
      type: [String, Number],
      default: '',
    },
    valueUnit: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      unit: '',
      localValue: this.value, // 新增本地变量
    };
  },
  watch: {
    value(newVal) {
      this.localValue = newVal; // 父组件 value 变化时同步
    },
    item: {
      handler(v) {
        let units = v.valueUnit.slice(0);
        units = units.filter(u => !!u);

        if (units.length) {
          this.$emit('changeUnits', { [v.idName]: this.valueUnit || units[0] });
        }
      },
      immediate: true,
    },
  },
  methods: {
    change(val) {
      this.$emit('change', val);
    },
    handleInput(val) {
      this.localValue = val;
      this.$emit('change', val);
    },
    hasValueUnit(item) {
      if (item.valueUnit) {
        let units = item.valueUnit.slice(0);
        units = units.filter(u => !!u);
        return !!units.length;
      }
      return false;
    },
  },
};
</script>

<style lang="scss">
.input-number {
  .el-input__inner {
    text-align: left;
  }
}
</style>